export default __webpack_public_path__ + "static/media/connect-wallet-top-img.c29a4a46.png";